/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use client';
import { useModalOPPromptContext } from '@/components/ModalOPPromptContext';
import logger from '@/utils/logger';
import { useNotification } from '@az/starc-ui';
import styles from './styles.module.scss';
import { useLabels } from '@/hooks/useLabels';

const labelMap = {
  promoCodeCopied: 'label_email_promo_code_copied',
};

export const useCopyPromoCode = () => {
  const labels = useLabels(labelMap);
  const { show } = useNotification();
  const { offer } = useModalOPPromptContext();

  const handleCopyPromoCode = async () => {
    const existingNotification = document.querySelector(`.${styles.promoSnackBar}`);
    if (existingNotification) {
      return;
    }
    try {
      await navigator.clipboard.writeText(offer?.promoCode || '');
      show({
        text: labels.promoCodeCopied,
        type: 'snack-bar',
        className: styles.promoSnackBar,
      });
    } catch (error) {
      logger.error({ message: 'Failed to copy to clipboard', meta: error });
    }
  };

  return { handleCopyPromoCode };
};
